import { useEffect, useState } from 'react';
import api from '../api';
import CowLoader from '../components/CowLoader';

export default function AdminPanel() {
  const [allowed, setAllowed] = useState(null); // null = checking, true/false
  const [users, setUsers] = useState([]);
  const [vaquitas, setVaquitas] = useState([]);
  const [activeTab, setActiveTab] = useState('users');
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const me = await api.get('/users/me');
        if (!me.data.admin) {
          setAllowed(false);
          return;
        }
        setAllowed(true);
        const [usersRes, vaquitasRes] = await Promise.all([
          api.get('/admin/users'),
          api.get('/admin/vaquitas'),
        ]);
        setUsers(usersRes.data);
        setVaquitas(vaquitasRes.data);
      } catch (err) {
        setError('Error al cargar el panel de administración');
      }
    };
    load();
  }, []);

  if (allowed === null) return <CowLoader text="Cargando panel..." />;
  if (!allowed) return <div className="admin-denied">No tienes acceso a esta sección.</div>;
  if (error) return <div className="admin-denied">{error}</div>;

  return (
    <div className="admin-panel">
      <h1 className="admin-title">🛠 Panel de Administración</h1>

      <div className="admin-tabs">
        <button className={`admin-tab-btn ${activeTab === 'users' ? 'active' : ''}`} onClick={() => setActiveTab('users')}>
          Usuarios <span className="admin-tab-pill">{users.length}</span>
        </button>
        <button className={`admin-tab-btn ${activeTab === 'vaquitas' ? 'active' : ''}`} onClick={() => setActiveTab('vaquitas')}>
          Vaquitas <span className="admin-tab-pill">{vaquitas.length}</span>
        </button>
      </div>

      {activeTab === 'users' && (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nombre</th>
                <th>Email</th>
                <th>Vaquitas</th>
                <th>Admin</th>
              </tr>
            </thead>
            <tbody>
              {users.map(u => (
                <tr key={u.id}>
                  <td>{u.id}</td>
                  <td>{u.name}</td>
                  <td>{u.email}</td>
                  <td>{u.vaquitaCount}</td>
                  <td>{u.admin ? '✓' : ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {activeTab === 'vaquitas' && (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nombre</th>
                <th>Estado</th>
                <th>Creador</th>
                <th>Participantes</th>
                <th>Total recaudado</th>
                <th>Código</th>
              </tr>
            </thead>
            <tbody>
              {vaquitas.map(v => (
                <tr key={v.id}>
                  <td>{v.id}</td>
                  <td>{v.name}</td>
                  <td>{v.status}</td>
                  <td>{v.creatorName}</td>
                  <td>{v.participantCount}</td>
                  <td>${v.totalContributed.toLocaleString('es-CL', { maximumFractionDigits: 0 })}</td>
                  <td><code>{v.inviteCode}</code></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <style jsx>{`
        .admin-panel {
          padding: 1rem;
          max-width: 1200px;
          margin: 0 auto;
        }

        @media (min-width: 768px) {
          .admin-panel { padding: 2rem; }
        }

        .admin-title {
          color: var(--text-primary);
          font-size: 1.4rem;
          margin-bottom: 1rem;
        }

        .admin-denied {
          padding: 3rem 1rem;
          text-align: center;
          color: var(--text-muted);
        }

        .admin-tabs {
          display: flex;
          gap: 0.5rem;
          margin-bottom: 1rem;
        }

        .admin-tab-btn {
          padding: 0.6rem 1.1rem;
          border-radius: 20px;
          border: 1px solid var(--border-color);
          background: var(--bg-primary);
          color: var(--text-secondary);
          cursor: pointer;
          font-size: 0.9rem;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 0.4rem;
        }

        .admin-tab-btn.active {
          background: var(--accent-color);
          color: white;
          border-color: var(--accent-color);
        }

        .admin-tab-pill {
          background: rgba(0,0,0,0.15);
          border-radius: 999px;
          padding: 1px 7px;
          font-size: 0.72rem;
        }

        .admin-table-wrap {
          background: var(--bg-secondary);
          border-radius: 12px;
          box-shadow: 0 2px 4px var(--shadow-color);
          overflow-x: auto;
        }

        .admin-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 0.88rem;
        }

        .admin-table th, .admin-table td {
          padding: 0.65rem 0.9rem;
          text-align: left;
          white-space: nowrap;
          border-bottom: 1px solid var(--border-color);
          color: var(--text-secondary);
        }

        .admin-table th {
          color: var(--text-muted);
          font-weight: 600;
          font-size: 0.78rem;
          text-transform: uppercase;
        }

        .admin-table tbody tr:hover {
          background: var(--bg-primary);
        }
      `}</style>
    </div>
  );
}
